import { AssessmentStep } from "apps/user/learner/api/types";

/**
 * The SectionStep introducing the commercial/company-questions block. Its
 * copy duplicates the uplift "You're nearly done" end screen, so it must
 * never render as its own in-flow screen. Keyed off the stable CSV-authored
 * shorthand rather than subtitle copy — copy changes shouldn't silently
 * reintroduce the duplicate-content bug.
 */
export const COMMERCIAL_SECTION_SHORTHAND = "section_commercial_items";

export const isCommercialSectionStep = (step: AssessmentStep): boolean =>
  step.__typename === "AssessmentSectionStep" &&
  step.shorthand === COMMERCIAL_SECTION_SHORTHAND;

export const COMMERCIAL_QUESTION_CATEGORY = "Commercial Use";

export const isCommercialQuestionStep = (step: AssessmentStep): boolean =>
  step.__typename === "AssessmentQuestionStep" &&
  step.category === COMMERCIAL_QUESTION_CATEGORY;

/**
 * Steps the flow passes over instead of showing: the assessment page skips
 * them going forward, and stepping back walks past them.
 */
export const isHiddenInFlowStep = (step: AssessmentStep): boolean =>
  isCommercialSectionStep(step) || isCommercialQuestionStep(step);

/** The first step at or after `index` that the learner actually sees. */
export const firstVisibleStepIndexFrom = (
  steps: AssessmentStep[],
  index: number
): number => {
  let visibleIndex = index;
  while (
    visibleIndex < steps.length - 1 &&
    isHiddenInFlowStep(steps[visibleIndex])
  ) {
    visibleIndex += 1;
  }
  return visibleIndex;
};
